import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Chips } from 'primeng/chips';
import {
  link,
  breadcrumb,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-program-user-managment',
  templateUrl: './program-user-managment.component.html',
  styleUrl: './program-user-managment.component.scss',
})
export class ProgramUserManagmentComponent implements OnInit {
  @ViewChild('externalMailChips') externalMailChipsInput?: ElementRef<Chips>;

  //Header data
  header = this.translate('User Management');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-arrow-left',
      link: '',
    },
  ];
  breadcrumbs: breadcrumb[] = [];
  stats: stat[] = [];

  //Data Variables
  selectionData: any[] = [];
  trainingProgramID: string = '';
  staticURL = GlobalConstants.staticFilesURL;
  users: any[] = [];
  unregisteredUsers: string[] = [];
  filteredUsers: any[] = [];
  allUsers: any[] = [];
  emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  showMultipleEmails: boolean = true;
  skelition: boolean = true;
  suggestions: any[] = [];
  userEmails: string[] = [];

  emailForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
  });

  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.trainingProgramID = params['trainingProgramID'];
      if (!!this.trainingProgramID) {
        Promise.all([this.getTrainingUsers(), this.getAllUsers()]).then((e) => {
          this.skelition = false;
        });
      }
    });
  }

  get email() {
    return this.emailForm.get('email');
  }

  getTrainingUsers = async () => {
    try {
      let res: any = await this.dataService.getData(
        `training-program/get-training-program-attendees/` +
          this.trainingProgramID
      );
      this.skelition = false;
      if (!res.error && res.data.length > 0) {
        this.users = res.data[0].attendees;
        return;
      }
      this.showMessage(res.msg, 'error');
    } catch (error) {
      console.log(error);
    }
  };

  // getUnregisteredUsers = async () => {
  //   try {
  //     let res: any = await this.dataService.getData(`training-req/unregistered/attendees/${this.trainingProgramID}`);
  //     this.skelition = false;
  //     if (!res.error) {
  //       if (res.data != null && Array.isArray(res.data)) {
  //         this.unregisteredUsers = res.data
  //       }
  //       return;
  //     }

  //     this.showMessage(res.msg, 'error')
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  validateEmail(email: string) {
    let regex: RegExp = new RegExp(
      '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
    );
    return regex.test(email);
  }

  async getMultipleUser() {
    try {
      let invalidEmails: any = [];
      this.allUsers;
      this.userEmails.forEach((email) => {
        if (this.validateEmail(email)) {
          const user = this.allUsers.find((user) => user.email === email);
          if (user) {
            this.users.push(user);
          } else {
            this.unregisteredUsers.push(email);
          }
        } else {
          invalidEmails.push(email);
        }
      });
      this.userEmails = invalidEmails;
      this.updateUsers(true);
      this.updateUsers();
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  async getUser() {
    try {
      if (!this.email || !this.email.value) {
        this.showMessage('email is not allowed to be empty', 'info');
        return;
      }
      if (typeof this.email.value == 'string') {
        if (!this.validateEmail(this.email?.value)) {
          this.skelition = false;
          this.showMessage('email must be a valid email', 'info');
          return;
        }
        // this.unregisteredUsers = [this.email?.value, ...this.unregisteredUsers];
        // this.emailForm.reset();
        // this.updateUsers(true);
      } else {
        this.users = [this.email.value, ...this.users];
       //debugger;
        this.emailForm.reset();
        this.updateUsers();
        this.cdr.detectChanges();
      }
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  async getAllUsers() {
    try {
      let res = await this.dataService.postData('user/get', {
        'active.status': true,
      });
      this.allUsers = res.data;
    } catch (e) {
      console.log(e);
    }
  }

  search(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    console.log('SEARCH', this.allUsers);
    for (let i = 0; i < this.allUsers.length; i++) {
      let user = this.allUsers[i];
      if (user.email.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(user);
      }
    }
    console.log('SEARCH RES', filtered);
    this.filteredUsers = filtered;
  }

  confirmDelete(user: any, unregistered: boolean = false) {
    this.confirmationService.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        this.removeUser(user, unregistered);
        return true;
      },
      reject: (type: any) => {
        return false;
      },
    });
  }

  removeUser(user: any, unregistered: boolean = false) {
    if (unregistered) {
      this.unregisteredUsers = this.unregisteredUsers.filter((e) => e != user);
    } else {
      this.users = this.users.filter((e) => e._id != user._id);
    }
    this.updateUsers(unregistered);
  }

  async updateUsers(unregistered: boolean = false) {
    try {
      this.skelition = true;
      let url = 'training-program/user/new';
      let usersId: any = [];
      usersId = this.users.map((user) => user._id);

      let res = await this.dataService.postData(
        url,
        { programId: this.trainingProgramID, users: usersId },
        'PUT'
      );

      if (res.error) {
        this.skelition = false;
        this.showMessage('Failed to update users', 'error');
        return;
      }
      this.getTrainingUsers();
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  async synchronizeUsers() {
    try {
      this.skelition = true;

      let programIdString = String(this.trainingProgramID);
      let res = await this.dataService.postData(
        `training-program/synchronize/${programIdString}`,
        {},
        'PUT'
      );
      if (res.error) {
        this.skelition = false;
        this.showMessage('Failed to synchronize users', 'error');
        return;
      }
      this.showMessage('Users synchronized successfully', 'success');
      window.location.reload();
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  showMessage(message: string, severity: string) {
    this.messageService.add({
      severity: severity,
      summary: this.translate('Error'),
      detail: this.translate(message),
    });
  }

  handlePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';
    const emails = pastedText.split(/[\n,;\s]+/);
    emails.forEach((email) => {
      const trimmedEmail = email.trim();
      if (this.emailPattern.test(trimmedEmail)) {
        this.userEmails.push(trimmedEmail);
      }
    });
    event.preventDefault();
  }

  toggleEmailInput() {
    this.showMultipleEmails = !this.showMultipleEmails;
  }

  resetFields() {
    this.synchronizeUsers();
  }
}
